import React from 'react';

const Navigation: React.FC = () => {
  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-brand">
          <img src="/componentes-mockup/logo apolox.png" alt="APOLOX" className="nav-logo" />
          <span className="nav-title">APOLOX</span>
        </div>
        <div className="nav-links">
          <a href="#producto">Producto</a>
          <a href="#soluciones">Soluciones</a>
          <a href="#precios">Precios</a>
          <a href="#docs">Docs</a>
          <a href="#contacto">Contacto</a>
          <a 
            href="https://wa.me/573123456789?text=Hola,%20vengo%20del%20sitio%20web%20de%20APOLOX%20y%20me%20gustaría%20conocer%20más%20sobre%20el%20sistema%20de%20gestión%20empresarial.%20¿Podrían%20contactarme?" 
            className="nav-cta"
          >
            Solicitar Demo
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;